module.exports = __webpack_public_path__ + "static/img/nodata.2dedc0d2.png";